import { useEffect } from "react";
import { FavoriteApps } from "@/components/dashboard/FavoriteApps";
import { CompactSmartfile } from "@/components/dashboard/CompactSmartfile";
import { CollapsibleSearchIA } from "@/components/dashboard/CollapsibleSearchIA";
import { DashboardTotals } from "@/components/dashboard/DashboardTotals";
import { supabase } from "@/integrations/supabase/client";

export default function DashboardPaciente() {
  useEffect(() => {
    const logAccess = async () => {
      try {
        const {
          data: { user },
        } = await supabase.auth.getUser();
        if (!user) return;

        await supabase.functions.invoke("log-user-access", {
          body: { action: "view_dashboard", entity: "patient_dashboard" },
        });
      } catch (error) {
        console.error("Error logging patient dashboard access:", error);
      }
    };

    void logAccess();
  }, []);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <FavoriteApps basePath="/paciente" />
        <CompactSmartfile
          basePath="/paciente"
          appHomeStyle
          description="Insira seus dados de saúde nos formatos abaixo"
        />
      </div>
      <CollapsibleSearchIA inline basePath="/paciente" />

      <h3 className="text-sm font-semibold text-muted-foreground">Dashboard</h3>
      <DashboardTotals basePath="/paciente" hidePatientsCard />
    </div>
  );
}
